/* eslint-disable */
import { useParameter, useExport } from "../../../shared";
import * as React from "react";
import { REPORT_ID } from "../constants";

export function useExportQuery(title, subtitle) {
  const exportBuilder = useExport();
  const [calendar] = useParameter<number[]>("@calendar");
  const [crop_calendar] = useParameter<number>("@crop_calendar");

  React.useEffect(() => {
    exportBuilder.set('title', title);
    exportBuilder.set('subtitle', subtitle);
    exportBuilder.set('reportDefinition', {
      reportId: REPORT_ID,
      names: { 9: title },
      parameters: {
        "@calendar": calendar && calendar.map(String),
        "@crop_calendar": String(crop_calendar),
      }
    });
  }, [title, subtitle, exportBuilder, calendar, crop_calendar]);
}


